import styles from './PlayIcon.module.scss'
import { getTestId } from '@content/helpers/src/utils'
export const PlayIcon = ({
    fillRect,
    size = 96
}: {
    fillRect: string
    size?: number
}) => {
    return (
        <span
            className={styles.playIcon}
            style={{ height: size, width: size }}
            data-testid={getTestId('play-icon')}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill={fillRect}>
                <path
                    fillRule="evenodd"
                    d="M4.5 1.5v21L21 12 4.5 1.5Z"
                    clipRule="evenodd"></path>
            </svg>
        </span>
    )
}
